import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Button, Tooltip } from 'antd';
import { useAppStore } from '../../stores';
import { ComparisonActionProvider } from '../../context/ComparisonActionProvider';
import { ContractComparisonRenderer } from '..';
import './CompareContractModal.less';

const CompareContractModal: React.FC = () => {
    const { contractComparisonStore } = useAppStore();

    const [isVisible, setIsVisible] = React.useState(false);

    const selectedComparison = contractComparisonStore.selectedContractComparison;

    const handleClose = () => {
        setIsVisible(false);

        // Smoother animation by waiting for the modal to close
        setTimeout(() => {
            contractComparisonStore.setSelectedFilter('all');
            selectedComparison?.setIsSelected(false);
        }, 500);
    };

    const handleSave = () => {
        selectedComparison?.saveChanges();
        handleClose();
    };

    React.useEffect(() => {
        setIsVisible(!!selectedComparison);
    }, [selectedComparison]);

    return (
        <Modal
            className="compare-contract-modal"
            title="Contract Comparison"
            visible={isVisible}
            maskClosable={false}
            width={1000}
            destroyOnClose
            forceRender
            centered
            onCancel={handleClose}
            footer={[
                <Button key="cancel-button" className="light alpha-dialog-button" onClick={handleClose}>
                    Cancel
                </Button>,
                <Tooltip key="save-button" title={selectedComparison?.businessTypeConflict}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        onClick={handleSave}
                        style={{ marginLeft: 8 }}
                        disabled={!!selectedComparison?.businessTypeConflict || selectedComparison?.isExecutingAction}
                    >
                        Save changes
                    </Button>
                </Tooltip>
            ]}
        >
            {selectedComparison && (
                <ComparisonActionProvider contractComparison={selectedComparison}>
                    <ContractComparisonRenderer contractComparison={selectedComparison} />
                </ComparisonActionProvider>
            )}
        </Modal>
    );
};

export default observer(CompareContractModal);
